import { HTMLAttributes, useEffect, useState } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import clsx from 'clsx';
import AreasOfExpertiseView from './components/areasOfExpertise';
import CancelAnytimeView from './components/cancelAnytime';
import ClientsSayView from './components/clientsSay';
import GetQuotesView from './components/getQuotes/index';
import HelpGrowBusinessView from './components/helpGrowBusiness';
import InsuranceCoveragesView from './components/insuranceCoverages';
import OurSchemesView from './components/ourSchemes/index';
import ProductIntroductionView from './components/productIntroduction';
import QuestionsView from './components/questions';
import TechnicalDocumentsView from './components/technicalDocuments';
import WhyJoveView from './components/whyJove';

type RecruitmentLandingPageViewProps = HTMLAttributes<HTMLDivElement> & {
  info: any;
};

const RecruitmentLandingPageView = (props: RecruitmentLandingPageViewProps) => {
  const { info } = props;
  const [pageData, setPageData] = useState(null);
  const { isMobileLayout } = useJoveBreakpoint();

  /**
   * effects
   */
  useEffect(() => {
    setPageData(info?.faqListMap);
  }, [info]);

  return !!pageData ? (
    <Box className={clsx('flex flex-col', isMobileLayout ? 'space-y-6 px-2 pb-5' : 'space-y-24 pb-10')}>
      <ProductIntroductionView info={pageData} />
      <InsuranceCoveragesView info={pageData} />
      <OurSchemesView info={pageData} />
      <AreasOfExpertiseView info={pageData} />
      <HelpGrowBusinessView info={pageData} />
      <WhyJoveView info={pageData} />
      <GetQuotesView info={pageData} />
      <CancelAnytimeView info={pageData} />
      <ClientsSayView info={pageData} />
      <TechnicalDocumentsView info={pageData} />
      <QuestionsView info={pageData} />
    </Box>
  ) : null;
};

export default RecruitmentLandingPageView;
